import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

import { Schema } from "lib/build/schema";

import { Button } from "src/common/components/Button";
import { Form, FormCustomContainer } from "src/common/components/Form";
import { GridColumn, GridRow } from "src/common/components/Grid";
import { AuthPage } from "src/common/components/Page";
import { TextCenter, TextRight } from "src/common/components/TextAlign";
import {
	FieldData,
	FieldRenderer,
	FormContextProvider,
	useFormState
} from "src/features/forms";
import {
	errors,
	labels,
	messages
} from "src/views/forgotten-password/messages";
import { useRequestPassword } from "src/views/forgotten-password/useRequestPassword";

import logo from "src/images/univsemmelweis_logo.png";

const validator = Schema.object()
	.properties({ email: Schema.string() })
	.sealed();

const errorMessages = { email: { presence: errors.emailRequired } };

const fields: { [key: string]: FieldData } = {
	email: {
		type: "field",
		path: ["email"],
		label: labels.email,
		errorMessages: errorMessages.email,
		input: { type: "input", props: { type: "text" } }
	}
};

export const ForgottenPassword: React.FunctionComponent = () => {
	const formState = useFormState({ validator });

	const { isSubmitted, isLoading, onSubmit } = useRequestPassword(
		formState.value,
		formState.errors.length === 0
	);

	return (
		<AuthPage logo={<img src={logo} />}>
			<FormContextProvider {...formState}>
				<Form isSubmitted={isSubmitted} onSubmit={onSubmit}>
					<h1>
						<FormattedMessage {...messages.title} />
					</h1>
					<h2>
						<FormattedMessage {...messages.help} />
					</h2>
					<GridRow>
						<GridColumn columnSize={12}>
							<FieldRenderer {...fields.email} />
						</GridColumn>
					</GridRow>
					<GridRow>
						<GridColumn columnSize={12}>
							<FormCustomContainer>
								<TextRight>
									<Link to="/sign-in">
										<FormattedMessage
											{...messages.signInLink}
										/>
									</Link>
								</TextRight>
							</FormCustomContainer>
						</GridColumn>
					</GridRow>
					<GridRow>
						<GridColumn columnSize={12}>
							<FormCustomContainer>
								<TextCenter>
									<Button type="submit" isLoading={isLoading}>
										<FormattedMessage
											{...messages.submit}
										/>
									</Button>
								</TextCenter>
							</FormCustomContainer>
						</GridColumn>
					</GridRow>
				</Form>
			</FormContextProvider>
		</AuthPage>
	);
};
